import { Skeleton } from '@/components/ui/skeleton';

export function LotSizingInfoSkeleton() {
  return <Skeleton className='h-40 w-full' />;
}
